module.exports = __webpack_public_path__ + "img/activeSet3.e093f37e.png";